import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IActivity } from "@miplatform/types";
import { buildActivityDateFilter } from "@miplatform/utils";
import { ActivityDateRange } from "@mibuildweb/components";
import { useCategories, usePriceLevels } from "@mibuildweb/hooks";

export const useCustomerPriceLevelTabViewModel = () => {
  const [priceLevelActivities, setPriceLevelActivities] = useState<IActivity[]>(
    []
  );

  const stateManager = useComponentState();

  const {
    priceLevels,
    getPriceLevels,
    createAccountPriceLevel,
    isLoading: isPriceLevelsLoading,
  } = usePriceLevels();

  const {
    categories,
    categoryDrops,
    getCategories,
    getCategoryDrops,
    isLoading: isCategoriesLoading,
  } = useCategories();

  const getPriceLevelActivities = (
    accountId: string,
    dateRange?: ActivityDateRange
  ): Promise<IActivity[]> => {
    return stateManager.run(async () => {
      const response = await homeService.activities.priceLevelAssigned.get({
        accountId,
        filters: buildActivityDateFilter(dateRange),
      });
      if (response.status === HTTP_STATUSES.OK) {
        setPriceLevelActivities(response.data);
      }
    });
  };

  const isPriceMatrixLoading = isPriceLevelsLoading || isCategoriesLoading;

  return {
    priceLevels,
    categories,
    categoryDrops,
    priceLevelActivities,
    getPriceLevels,
    getCategories,
    getCategoryDrops,
    getPriceLevelActivities,
    createAccountPriceLevel,
    isPriceMatrixLoading,
    isHistoryLoading: stateManager.isBusy(),
  };
};
